import { render, staticRenderFns } from "./FunctionRole.vue?vue&type=template&id=22f6868b&"
import script from "./FunctionRole.vue?vue&type=script&lang=ts&"
export * from "./FunctionRole.vue?vue&type=script&lang=ts&"
import style0 from "./FunctionRole.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports